import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData } from "@/data";
import { getVideoCutsListQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useVideoCutsList = (videoId) => {
    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { data, error, loading } = useQuery(getVideoCutsListQuery, {
        skip: !isAuthenticated || !videoId,
        variables: { id: videoId },
    });

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(t("messages.networkFailure"), dispatch, openAlert);
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        data: data?.getClipsByVideoId,
        loading,
    };
};

export default useVideoCutsList;
